export const GLOBAL_LOCAL_STORAGE_KEY = '__lb_g__'
export const BILL_PAYMENT_FOLD_LOCAL_STORAGE_KEY = '__lb_bp_f__'

export function setItemToLocalStorage<T>(key: string = GLOBAL_LOCAL_STORAGE_KEY, value: T) {
  return localStorage.setItem(key, JSON.stringify(value))
}

export function getItemFromLocalStorage<T>(key: string = GLOBAL_LOCAL_STORAGE_KEY): T | null {
  const value: string | null = localStorage.getItem(key)
  if (!value) {
    return null
  }

  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export function removeItemFromLocalStorage(key: string) {
  return localStorage.removeItem(key)
}
